{
  "title": "Eligibility Data Column Reference",
  "description": "Column definitions and available filters on the Eligibility Data page; this page has no approve/reject action — do the actual review from the Eligibility Review Workbench.",
  "headings": ["Column Reference", "Available Filters"],
  "intro": "The Eligibility Data page (under the \"Data\" nav group) is a read-only extension of the Eligibility Review Workbench — both pull from the exact same data, not a separate copy. This page additionally shows each member's proof version history and whether the file has already been purged under the retention policy. It offers no Approve or Reject action anywhere; the actual review still happens on the Eligibility tab of Members & Roles.",
  "submissionSectionHeading": "Column Reference",
  "submissionStatuses": [
    { "name": "Member", "editable": "The member's display name and email." },
    { "name": "Team", "editable": "The member's team name; shows \"—\" if not on a team." },
    {
      "name": "School",
      "editable": "The school the member entered; shows \"Not set\" if left blank."
    },
    {
      "name": "Proof Type",
      "editable": "The type of the currently-effective proof; shows \"No proof\" if nothing has been uploaded yet."
    },
    {
      "name": "Status",
      "editable": "The eligibility status badge — the exact same status definitions as the Eligibility Review Workbench."
    },
    {
      "name": "Current Version",
      "editable": "The upload time of the currently-effective proof; if that file has already been purged under the retention policy, shows a \"File purged\" badge instead of a time."
    },
    { "name": "Last Updated", "editable": "The last time this eligibility record changed." },
    {
      "name": "Reviewer",
      "editable": "The user ID of whoever last reviewed this record; shows \"—\" if it has never been reviewed."
    },
    {
      "name": "Actions",
      "editable": "A \"History\" button expands the full, read-only proof upload history. When status is Pending, a \"Go to Review\" link also appears, taking you to the Eligibility Review Workbench pre-filtered to that team — the actual approve/reject action is completed there."
    }
  ],
  "judgeSectionHeading": "Available Filters",
  "judgeStatuses": [
    {
      "name": "Filter by status",
      "description": "Show only members with a given eligibility status."
    },
    { "name": "Filter by team ID", "description": "Filter by typing a team ID." },
    {
      "name": "Text search",
      "description": "Search by member or school text; every filter is kept in the URL, so sharing the link or reloading the page preserves your query."
    }
  ]
}
